module.exports = __webpack_public_path__ + "img/business15.c2505194.png";